import dynamic from 'next/dynamic'

export const DynamicGlobalStoreSelectionDrawer = dynamic(
  () => import('.').then((mod) => mod.GlobalStoreSelectionDrawer),
  { ssr: false },
)
